import { Api } from '@/utils/Api'
import setEntities from '@/utils/SetEntities'
import UrlStore from '@/utils/UrlStore'
import { normalize, schema } from 'normalizr'
import Vue from 'vue'

export const POINT_ICONS_LOAD = 'POINT_ICONS_LOAD'
export const POINT_ICON_LOAD = 'POINT_ICON_LOAD'
export const POINT_ICON_CREATE = 'POINT_ICON_CREATE'
export const POINT_ICON_UPDATE = 'POINT_ICON_UPDATE'
export const POINT_ICON_DESTROY = 'POINT_ICON_DESTROY'
export const POINT_ICON_STATE_UPDATE = 'POINT_ICON_STATE_UPDATE'

const pointIconsApi = new Api(UrlStore.POINT_ICONS)
const pointIconSchema = new schema.Entity('pointIcons')

export default {
  namespaced: true,
  state: {
    pointIconsLoaded: false,
    pointIconsList: [],
    pointIconsPager: {},
    entities: {
      pointIcons: {}
    }
  },
  getters: {
    pointIcons(state) {
      return state.pointIconsList.map((bId) => state.entities.pointIcons[bId])
    },
    getPointIcon: (state) => (pointIconId) => state.entities.pointIcons[pointIconId] || null
  },
  mutations: {
    [POINT_ICONS_LOAD](state, payload) {
      let normData = normalize(payload.items, [pointIconSchema])
      state.pointIconsList = normData.result
      state.pointIconsPager = payload.pager
      setEntities(state, normData)
    },
    [POINT_ICON_LOAD](state, payload) {
      let normData = normalize(payload, pointIconSchema)
      setEntities(state, normData)
    },
    [POINT_ICON_CREATE](state, pointIcon) {
      state.pointIconsList.push(pointIcon.id)
      Vue.set(state.entities.pointIcons, pointIcon.id, pointIcon)
    },
    [POINT_ICON_UPDATE](state, pointIcon) {
      if (pointIcon.id && state.entities.pointIcons[pointIcon.id]) {
        state.entities.pointIcons[pointIcon.id] = Object.assign({}, state.entities.pointIcons[pointIcon.id], pointIcon)
      }
    },
    [POINT_ICON_DESTROY](state, pointIcon) {
      let num = state.pointIconsList.findIndex((cId) => cId === pointIcon.id)
      if (num !== -1) {
        state.pointIconsList.splice(num, 1)
        delete state.entities.pointIcons[pointIcon.id]
      }
    },
    [POINT_ICON_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    pointIconsLoad({ commit }, config = {}) {
      pointIconsApi.getAll(config).then((r) => {
        commit(POINT_ICONS_LOAD, r.data)
        commit(POINT_ICON_STATE_UPDATE, { pointIconsLoaded: true })
      })
    },
    pointIconLoad({ commit }, config) {
      pointIconsApi.get({ id: config.id, config: config }).then((r) => {
        commit(POINT_ICON_LOAD, r.data)
      })
    },
    pointIconSave({ commit, getters }, pointIcon) {
      if (!pointIcon.id) throw new Error('PointIcon id is not present in `pointIconSave`!')
      commit(getters.getPointIcon(pointIcon.id) ? POINT_ICON_UPDATE : POINT_ICON_CREATE, pointIcon)
      let pointIconUpdated = getters.getPointIcon(pointIcon.id)

      return pointIconsApi.save(pointIconUpdated).then((r) => {
        if (r._isNew) {
          commit(POINT_ICON_DESTROY, pointIconUpdated) // local
          commit(POINT_ICON_CREATE, r.data)
        } else {
          commit(POINT_ICON_UPDATE, r.data)
        }
        return r.data.id
      })
    },
    pointIconDestroy({ commit }, pointIcon) {
      pointIconsApi.destroy({ id: pointIcon.id }).then(() => {
        commit(POINT_ICON_DESTROY, pointIcon)
      })
    }
  }
}
